import { create } from 'zustand';
import api from '@/utils/api';
import { ExtendedWorkspace } from '@/lib/types';

interface Props {
  workspaces: ExtendedWorkspace[];
  showAlert: boolean;
  error: string | null;
  loadWorkspaces: () => Promise<void>;
}

const useWorkspaceStore = create<Props>()((set) => ({
  workspaces: [],
  showAlert: false,
  error: null,
  loadWorkspaces: async () => {
    try {
      set({ showAlert: false, error: null });
      const response = await api.get('/workspace');
      const data: ExtendedWorkspace[] = response.data.data;
      set({
        workspaces: data,
        showAlert: data.length === 0 ? true : false,
      });
    } catch (error: any) {
      set({
        error: error.response?.data?.error || 'Failed to load workspaces',
        showAlert: false,
      });
    }
  },
}));

export default useWorkspaceStore;
